import React from 'react';
import { Typography } from '@mui/material';
import { DEFAULT_COLOR_THEME } from '../../utils/Styling';

interface FormHeaderProps {
  title: string;
  my?: number;
}

const FormHeader: React.FC<FormHeaderProps> = ({ title, my = 0 }) => {
  return (
    <Typography
      variant="h6"
      sx={{
        textAlign: 'center',
        fontWeight: 'bold',
        color: DEFAULT_COLOR_THEME,
      }}
      my={my}
    >
      {title}
    </Typography>
  );
};

export default FormHeader;
